import React from 'react';
import LinkBuilder from '../../helpers/link-builder';
import PageLayout from '../../layouts/PageLayout';
import BasicDialog from '../../scenes/Dialog/components/BasicDialog';
import EmailTemplateFollowupForm from '../../scenes/Form/components/EmailTemplateFollowupForm';
import Sidebar from '../../scenes/Sidebar';
import InBoundsHistory from '../../scenes/Sidebar/components/InBoundsHistory';

const CreateUpdateEmailTemplateFollowup = props => {
  const { pageTitle, match, history } = props;

  const onAfterSaveForm = (id, hasAttachError) => {
    if (!match.params.id || Number(match.params.id) === 0) {
      history.replace(LinkBuilder.getEmailTemplateFollowupLink(id));
    }

    BasicDialog({
      bodyRender: hasAttachError
        ? 'Some files could not be uploaded'
        : 'Template has saved successfully',
    });
  };

  const onClose = () => {
    history.goBack();
  };

  return (
    <PageLayout
      pageClass="setup-email"
      pageTitle={pageTitle}
      mainContent={
        <EmailTemplateFollowupForm
          id={match.params.id}
          onAfterSave={onAfterSaveForm}
          onClose={onClose}
        />
      }
      sidebarContent={
        <Sidebar>
          <InBoundsHistory isRecruiter />
        </Sidebar>
      }
    />
  );
};

export default CreateUpdateEmailTemplateFollowup;
